// extracted by mini-css-extract-plugin
export default {"icon":"LockOff_icon__lYm5U"};